import { render, staticRenderFns } from "./ThirdPartyInsuranceExtend.vue?vue&type=template&id=6de36ea7"
import script from "./ThirdPartyInsuranceExtend.vue?vue&type=script&lang=js"
export * from "./ThirdPartyInsuranceExtend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports